import React, { Component } from 'react';
import { isMobile } from 'react-device-detect';
import globals from '../globals';

class ContactBlock extends Component {

    handleClick() {
        globals.pushGA4Events('phoneNumberClickBusiness',
            {
                eventInfo: {
                    phoneNumber: this.props.phone,
                    callType: this.props.title,
                    pageCategory: 'Business'
                }
            })
    }

    render () {
        return (
            <div className="contact-block">
                <h3>{this.props.title} {(isMobile ? <br /> : '-')} <a href={'tel: ' + this.props.phone} onClick={this.handleClick.bind(this)}>{this.props.phone}</a></h3>
                <h5 className="sub-title" dangerouslySetInnerHTML={{__html: globals.noWidows(this.props.subTitle)}} />
                <p>{this.props.hours}
                <br/>
                <a href={`mailto:${this.props.contactEmail}`}>{this.props.contactEmail}</a>
                <br/>
                <span dangerouslySetInnerHTML={{__html: this.props.extra}} />
                </p>
            </div>
        );
    }

}

export default ContactBlock;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/ContactBlock.js